<script setup lang="ts">
import Mockup from '@/components/Mockup.vue'
import type { SurveyQuestion } from '@/types/survey'

defineProps<{ surveyQuestion: SurveyQuestion }>()
const { t } = useI18n()

const previewColorsFrom = ['#fcc419', '#ff9369', '#49a3ff', '#4cb8c4', '#ba7ddd']
const previewColorsTo = ['#f6c636', '#ff92a0', '#56a8fb', '#3cd3ad', '#af6dd5']

const getGradientColor = (index: number) => {
  return `background: linear-gradient(45deg, ${previewColorsFrom[index]}, ${previewColorsTo[index]});`
}
</script>

<template>
  <div class="sm:h-[248px]! md:h-[380px]! md:w-full">
    <Mockup type="tablet" :color="800">
      <div
        class="relative flex h-full items-center justify-center rounded-xl bg-muted px-2 text-center md:px-4 lg:px-6"
      >
        <div class="absolute h-full w-full overflow-y-auto">
          <div class="flex flex-col items-center justify-center xl:h-[30%]">
            <h2 class="mt-3 text-sm font-light text-foreground-secondary">
              {{ t('pages.survey.surveyCreatePage.preview.tablet.intro') }}
            </h2>
            <h3 class="text-center font-semibold text-foreground xl:text-sm 2xl:text-lg">
              {{ surveyQuestion.questionText }}
            </h3>
          </div>
          <div class="flex h-52 flex-col justify-center xl:h-[60%] xl:px-2 2xl:mt-2 2xl:px-8">
            <div class="w-full overflow-y-auto">
              <div class="flex flex-col space-y-2">
                <div
                  v-for="index in surveyQuestion.choices.length"
                  :key="index"
                  class="mx-2 flex items-center rounded-xl px-1 py-3 text-center text-white shadow-sm transition-all duration-300 xl:px-2 2xl:px-6"
                  :style="getGradientColor(index - 1)"
                >
                  <div
                    class="mr-3 inline-flex h-3 w-3 items-center justify-center rounded-full bg-white/50 p-4 text-sm font-semibold lg:h-4 lg:w-4"
                    :class="previewColorsFrom[index - 1]"
                  >
                    {{ index }}
                  </div>
                  <div class="text-left text-sm font-semibold">
                    {{ surveyQuestion.choices[index - 1]?.text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="bottom-0 left-0 mt-4 inline-block w-full text-center text-xs font-semibold uppercase text-foreground-secondary md:absolute"
          >
            {{ t('pages.survey.surveyCreatePage.preview.tablet.skip') }}
          </div>
        </div>
      </div>
    </Mockup>
  </div>
</template>
